module.exports = __webpack_public_path__ + "icons/original/large/large-b3.f56ee08f09215c9501370c94a97d5da1.png";


//////////////////
// WEBPACK FOOTER
// ./src/web/icons/original/large/large-b3.png
// module id = /BPU
// module chunks = app